---
title: Innovation for Jobs (i4j)
slug: i4j
type: work
status: published
featured: false
summary: Analytics co-chair for Innovation for Jobs. The 2016 summit deck maps the jobs ecosystem — categories, organizations, investors, people, and places.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2016-01-29"
lastReviewedAt: "2026-10-02"
audiences:
  - business
themes:
  - innovation-systems
  - network-analysis
sourceUrl: http://i4j.info/
originalAuthor: Jay van Zyl
sourceRelationship: first-party role description of earlier public work
rightsStatus: first-party
seoDescription: Jay van Zyl’s i4j work — analytics co-chair, the Ecosystem Graph, and the 2016 summit slides on the jobs-innovation landscape.
canonicalPath: /work/i4j
---

import { I4jGallery } from "@/features/work/I4jGallery"

### [Innovation for Jobs](http://i4j.info/) analytics co-chair

5B people are of working age. 3B want a job. 1.3B have one. 13% are engaged. Almost nobody has a job that fits them. Humanity creates a $75T world economy, running at a fraction of its capacity. If everybody had a job that fitted them, everyone would be much happier and humanity would be creating many times more value than today.

Tailored jobs for everyone on planet earth is becoming possible for the first time with high smartphone penetration and new infrastructures like cloud computing and big data analytics. We are at the beginning of a revolution in strengths finding, education, matchmaking, HR, and the creation of opportunities in a long-tail labor market.

There is probably a greater than $100T market for innovations that help 5B people get jobs they love, capitalizing on their unique skills, talents, and passions, and matching people in great teams doing meaningful work.

Innovation for Jobs: earn by helping others earn better in more meaningful ways.

[At the i4j ECO Summit](http://www.i4jsummit.com/), entrepreneurs, funders, educators, policymakers, and other leaders from the innovation-for-jobs ecosystem talked shop around the business of disrupting unemployment. We showed how the gig economy is shaping a new approach to how people see their world of work.

### i4j Graph

The Ecosystem Graph Project (i4j Graph) is an i4j community project for mapping and analyzing the innovation-for-jobs ecosystem. It is a community tool for pinpointing players and ideas, how they matter and how they connect, and for spotting trends and indicators. The workshop covers i4j Graph from aims to technologies, and is a way for innovators and organizations to see where they stand in that connect.

### i4j Ecosystem

The slides below are the 29 January 2016 summit deck, with David Nordfors. The analysis credit on the title slide is i4j analytics partner. The sequence is categories and knowledge, organization and CEO networks, investor and organization, organization and person, then organization and location.

<I4jGallery />

### Ecosystems

In the networked innovation economy, companies reach out beyond their walls to connect to the right people. It is very difficult to put the whole team under the same roof. Ecosystems seep into the organization chart. Mechanistic line organizations meet organic performance ecosystems. That view changes jobs and the labor market: employment is not the only form of engagement. The workshop goes over performance ecosystems that help companies get people into meaningful work, and the relations between the people who work and the organizations that hire them.

### Outline of analysis

[A February 2015 note on the first Innovation for Jobs ecosystem](/documents/innosect00.pdf). The dataset was built from four constructs — person, company, idea, and event — then measured as a network. The note records about 160 people as the starting human set, and the two early graphs: a human network held together by purposeful interaction, and a prominent-ideas graph drawn from public language and prior notes.
